"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityPoolToJSON = exports.CommunityPoolFromJSONTyped = exports.CommunityPoolFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CommunityPoolFromJSON(json) {
    return CommunityPoolFromJSONTyped(json, false);
}
exports.CommunityPoolFromJSON = CommunityPoolFromJSON;
function CommunityPoolFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'user': json['user'],
        'status': (0, _1.CommunityPoolStatusFromJSON)(json['status']),
        'invitationStatus': (0, _1.CommunityPoolInvitationStatusFromJSON)(json['invitationStatus']),
        'totalCreditsUsd': json['totalCreditsUsd'],
        'creditsBySource': (0, _1.CommunityPoolCreditsBySourceFromJSON)(json['creditsBySource']),
        'invitedAt': (new Date(json['invitedAt'])),
        'invitedBy': json['invitedBy'],
        'termsAcceptedAt': !(0, runtime_1.exists)(json, 'termsAcceptedAt') ? undefined : (new Date(json['termsAcceptedAt'])),
        'adminNotes': !(0, runtime_1.exists)(json, 'adminNotes') ? undefined : json['adminNotes'],
        'revokedReason': !(0, runtime_1.exists)(json, 'revokedReason') ? undefined : json['revokedReason'],
    };
}
exports.CommunityPoolFromJSONTyped = CommunityPoolFromJSONTyped;
function CommunityPoolToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'user': value.user,
        'status': (0, _1.CommunityPoolStatusToJSON)(value.status),
        'invitationStatus': (0, _1.CommunityPoolInvitationStatusToJSON)(value.invitationStatus),
        'totalCreditsUsd': value.totalCreditsUsd,
        'creditsBySource': (0, _1.CommunityPoolCreditsBySourceToJSON)(value.creditsBySource),
        'invitedAt': (value.invitedAt.toISOString()),
        'invitedBy': value.invitedBy,
        'termsAcceptedAt': value.termsAcceptedAt === undefined ? undefined : (value.termsAcceptedAt.toISOString()),
        'adminNotes': value.adminNotes,
        'revokedReason': value.revokedReason,
    };
}
exports.CommunityPoolToJSON = CommunityPoolToJSON;
